import {
  ANCHOR_LESSON_COVER,
  ATTRIBUTE,
  CLASS,
  LINK_TYPE,
  SELECTOR,
} from "@plugins/dynamic-link/dynamic.link.constant";
import DOMUtils from "@utils/dom.utils";
import { createApp } from "vue";
import DynamicLinkEditModal from "@plugins/dynamic-link/components/DynamicLinkEditModal";
import DynamicInternalLink from "@plugins/dynamic-link/components/DynamicInternalLink";
import AppInstanceUtils from "@plugins/common/service/app.instance.utils";

export default {
  getAllDynamicLinksFromContainer(container) {
    return DOMUtils.elOf(container, SELECTOR.DYNAMIC_LINK);
  },
  getLinkTagsFromContainer(container) {
    return DOMUtils.elOf(container, SELECTOR.TAG);
  },
  getComponentsFromContainer(container) {
    return DOMUtils.elOf(container, SELECTOR.COMPONENT);
  },
  findExternalLinkATags(container, hrefValue) {
    const selector = this.getExternalLinkSelector(hrefValue);
    return DOMUtils.elOf(container, selector);
  },
  getExternalLinkSelector(hrefValue) {
    if (hrefValue) {
      return `a[href="${hrefValue}"]:not(span${SELECTOR.DYNAMIC_LINK} a):not(a${SELECTOR.CUSTOM_TOOLTIP})`;
    } else {
      return `a[href]:not(span${SELECTOR.DYNAMIC_LINK} a):not(a${SELECTOR.CUSTOM_TOOLTIP})`;
    }
  },
  createDynamicLinkTagFrom({ anchor, customText, dataLinkType }) {
    const dynamicLinkElement = document.createElement("span");
    dynamicLinkElement.classList.add(CLASS.DYNAMIC_LINK, CLASS.TAG);

    if (anchor === ANCHOR_LESSON_COVER || isNaN(parseInt(anchor))) {
      dynamicLinkElement.setAttribute(ATTRIBUTE.DATA_ANCHOR, ANCHOR_LESSON_COVER);
      dynamicLinkElement.setAttribute(ATTRIBUTE.DATA_LINK_TYPE, LINK_TYPE.LESSON);
    } else {
      dynamicLinkElement.setAttribute(ATTRIBUTE.DATA_ANCHOR, anchor);
      dynamicLinkElement.setAttribute(ATTRIBUTE.DATA_LINK_TYPE, dataLinkType);
    }
    dynamicLinkElement.setAttribute(ATTRIBUTE.DATA_CUSTOM_TEXT, customText);
    return dynamicLinkElement;
  },
  retrieveDataFromLinkTag(element) {
    if (
      !element?.classList.contains(CLASS.TAG) ||
      !element?.classList.contains(CLASS.DYNAMIC_LINK)
    ) {
      return {};
    }
    return {
      anchor: element.getAttribute(ATTRIBUTE.DATA_ANCHOR),
      dataLinkType: element.getAttribute(ATTRIBUTE.DATA_LINK_TYPE),
      customText: element.getAttribute(ATTRIBUTE.DATA_CUSTOM_TEXT),
    };
  },
  retrieveDataFromComponent(componentElement) {
    if (
      !componentElement?.classList.contains(CLASS.COMPONENT) ||
      !componentElement?.classList.contains(CLASS.DYNAMIC_LINK)
    ) {
      return {};
    }
    return {
      anchor: componentElement.getAttribute(ATTRIBUTE.DATA_ANCHOR),
      dataLinkType: componentElement.getAttribute(ATTRIBUTE.DATA_LINK_TYPE),
      customText: componentElement.getAttribute(ATTRIBUTE.DATA_LABEL),
    };
  },
  createDynamicInternalLinkVueApp(
    { isEditMode, anchor, customText, dataLinkType, introductionTitle, lessonUuid = "" },
    listener,
    parentComponent,
  ) {
    const DynamicInternalLinkApp = createApp(DynamicInternalLink, {
      isEditMode: isEditMode,
      anchor: anchor,
      customText: customText,
      dataLinkType: dataLinkType,
      introductionTitle: introductionTitle,
      lessonUuid: lessonUuid,
      ...listener,
      ...AppInstanceUtils.generateDynamicMountProps(parentComponent),
    });
    AppInstanceUtils.installCommonPlugin(DynamicInternalLinkApp);
    return DynamicInternalLinkApp;
  },
  createWrapper(hasIcon) {
    const classList = `${CLASS.DYNAMIC_LINK_WRAPPER} ${
      hasIcon ? CLASS.DYNAMIC_LINK_WRAPPER_HAS_ICON : ""
    }`;
    return DOMUtils.createElement("span", {
      class: classList,
      contenteditable: false,
    });
  },
  wrapperHasIconListener(wrapperEl) {
    return (hasIcon) => {
      const hasIconClass = CLASS.DYNAMIC_LINK_WRAPPER_HAS_ICON;
      const hasIconClassExist = wrapperEl.classList.contains(hasIconClass);
      if (hasIcon && !hasIconClassExist) {
        wrapperEl.classList.add(hasIconClass);
      }
      if (!hasIcon && hasIconClassExist) {
        wrapperEl.classList.remove(hasIconClass);
      }
    };
  },
  findWrapper(element) {
    return element.closest(SELECTOR.DYNAMIC_LINK_WRAPPER);
  },
  createEditModal(parentElement, parentComponent) {
    const mountElement = DOMUtils.createElement("div", {});
    parentElement.appendChild(mountElement);
    // use default props, hidden edit modal on create
    const DynamicLinkEditModalApp = createApp(
      DynamicLinkEditModal,
      AppInstanceUtils.generateDynamicMountProps(parentComponent),
    );
    AppInstanceUtils.installCommonPlugin(DynamicLinkEditModalApp);
    const component = DynamicLinkEditModalApp.mount(mountElement);
    DOMUtils.replaceComponentWrapperWithComponentElement(component);
    return component;
  },
  createTextNode(content = "") {
    const textNode = document.createTextNode(content);
    return textNode;
  },
};
